import { axiosInstance } from "../../utils/axios";
import { TgkParameterMetadata } from "../models/tgk-parameter-metadata";
import { TgkParameter } from "../models/tgk-parameter";
import { DimensionItem } from "../../components/coobjects/tree-pills-input/TreeAmountSelector";

export function fetchParametersMetadata(dbId: string, formId: string): Promise<TgkParameterMetadata[]> {
  return axiosInstance.get(`/form/${dbId}/${formId}/metadata`).then((response) => response.data);
}

export function fetchParametersRoot(dbId: string, formId: string, parameterCode: string): Promise<TgkParameter[]> {
  return axiosInstance.get(`/form/${dbId}/${formId}/parameter/${parameterCode}`).then((response) => response.data);
}

export function fetchParametersChildren(
  dbId: string,
  formId: string,
  parameterCode: string,
  structureCode: string,
  nodeCode: string
): Promise<TgkParameter[]> {
  return axiosInstance
    .get(`/form/${dbId}/${formId}/parameter/${parameterCode}/${structureCode}/${nodeCode}/children`)
    .then((response) => response.data);
}

export function mapParameterToDimensionItem(parameter: TgkParameter, metadata: TgkParameterMetadata): DimensionItem {
  const selectable = parameter.isSelectable && (parameter.isLeaf ? metadata.allowsLeafs : metadata.allowsNodes);

  return {
    data: parameter,
    oid: parameter.id,
    code: parameter.code,
    desc: parameter.description,
    nodeType: null,
    index: null,
    leaf: parameter.isLeaf,
    multiSelectable: metadata.multiSelectable,
    selectable,
    hierarchical: !!metadata.hierarchyCode,
    mandatory: null,
    parent: null,
    children: null,
  };
}
